import { NO } from '../utils/constants';

export function analysisListByFilter(filter) {
  const query = `{
    analysisListByFilter(filter: ${JSON.stringify(filter).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )})
    {
        id,
        sent,
        date,
        student{id, fullName, classesNames}
    }
}`;
  return query;
}

export function analysisItemListByFilter(filter) {
  const query = `{
  analysisItemListByFilter(
    filter: ${JSON.stringify(filter).replace(/"([^(")"]+)":/g, '$1:')}
  ) {
    id
    name
    active
  }
}`;
  return query;
}

export function analysisItemListByAnalisysId(id) {
  const query = `{
        analysisItemListByAnalisysId(analisysId: ${id})
        {id,
        analysisItem{id, name}
        description
        }
    }`;
  return query;
}

export function saveAnalysisMutation(values) {
  const { date } = values;
  const analysisItems = values.analysisItems
    ? values.analysisItems.map((item) => ({
        id: 0,
        analysisItem: {
          id: item.analysisItem.id,
          filterByStatus: false,
          updaterId: 0,
          active: true,
          order: 0,
        },
        description: item.description,
      }))
    : [];
  const mutationQuery = `mutation {
        analysisSave(analysis: {        
              id: ${values.id ? values.id : 0},
              date: ${typeof date === 'number' ? date : date.getTime()},
              sent: ${values.sent},
              filterByStatus: false,
              updaterId: 0,
              student: {
               id:${values.student.id},
               filterByStatus: false,
               updaterId: 0,
               active: true,
               legacyId: 0,
               dateOfBirth: 0
               activeOnLoggedPeriod: false
              },
              analysisItems: ${JSON.stringify(analysisItems).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}
      }){id}
  }`;
  return mutationQuery;
}

export function removeAnalysisMutation(id) {
  const query = `mutation { analysisRemove(analysisId: ${id}) }`;
  return query;
}

export function analysisSentMutation(data) {
  const studentsToSent = data
    .filter((student) => student.sent === NO)
    .map(({ student }) => student.id);
  const query = `mutation{analysisSent(students: ${JSON.stringify(
    studentsToSent
  ).replace(/"([^(")"]+)":/g, '$1:')})}`;
  return query;
}
